/* Jannaty — sitewide Angebots-Banner. DE = Geschenkset + Extras zum Set-Preis, andere Laender = Gratis-Versand-Grenze. */
(function () {
  var HIDE_KEY = 'jn_offer_hidden_until';

  // Echte Werte aus dem Shopify-Versandprofil (Stand 23.09.2026)
  var SHIP = {
    DE: { thr: 49.90 }, AT: { thr: 59.90 }, CH: { thr: 69.90 },
    BE: { thr: 69.90 }, BG: { thr: 69.90 }, HR: { thr: 69.90 }, CY: { thr: 69.90 }, CZ: { thr: 69.90 },
    DK: { thr: 69.90 }, EE: { thr: 69.90 }, FI: { thr: 69.90 }, FR: { thr: 69.90 }, GR: { thr: 69.90 },
    HU: { thr: 69.90 }, IE: { thr: 69.90 }, IT: { thr: 69.90 }, LV: { thr: 69.90 }, LT: { thr: 69.90 },
    LU: { thr: 69.90 }, MT: { thr: 69.90 }, NL: { thr: 69.90 }, PL: { thr: 69.90 }, PT: { thr: 69.90 },
    RO: { thr: 69.90 }, SK: { thr: 69.90 }, SI: { thr: 69.90 }, ES: { thr: 69.90 }, SE: { thr: 69.90 },
  };

  function fmt(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
  function priceBadge(n) { return '<span class="jn-offer-price">' + fmt(n) + '</span>'; }
  function oldPrice(n) { return '<s class="jn-offer-old">' + fmt(n) + '</s>'; }
  function bannerEmoji(country) { return country === 'DE' ? '🎁' : '🚚'; }

  // Liefert eine Liste von Botschaften (abwechselnd im selben Laufband), jede mit eigenem Link.
  function bannerMessages(country) {
    if (country === 'DE') {
      return [
        { emoji: '🎁', href: '/products/gebetsteppich-erwachsene',
          html: 'Geschenkset + alle Extras: einzeln ' + oldPrice(57.94) + ', im Set nur ' + priceBadge(49.90) + ' inkl. Versand' },
        // 01.11.2026: 2. Name entfernt → 57,94 = 24,99+9,99+3,99+6,99+7,99+3,99 (vorher 64,93 mit 2. Name 6,99).
        // 23.10.2026: Vergleichspreis = Summe der Einzelpreise (24,99+9,99+6,99+3,99+6,99+7,99+3,99) OHNE Versand, weil Einzelkauf ab 49,90 EUR in DE ohnehin versandkostenfrei ist.
        // Pausiert seit 11.10.2026, bis das Gebetsset lieferbar ist. Zum Wiedereinschalten paused entfernen.
        // ACHTUNG vor Wiedereinschalten: 69,84 pruefen - darf keine Versandkosten enthalten, die bei Einzelkauf nicht anfallen (siehe 23.10.2026).
        { emoji: '🕊️', href: '/products/jannaty-mukina-gebetsset-mit-hijab-tasche', paused: true,
          html: 'Gebetsset + Teppich anstatt ' + oldPrice(69.84) + ' nur ' + priceBadge(54.90) + ' inkl. Versand' },
      ].filter(function (m) { return !m.paused; });
    }
    var s = SHIP[country];
    if (s) return [{ emoji: '🚚', href: '/products/gebetsteppich-erwachsene', html: 'Kostenloser Versand nach ' + country + ' ab ' + priceBadge(s.thr) }];
    return null;
  }

  function init() {
    var country = (window.Shopify && window.Shopify.country) || null;
    var messages = bannerMessages(country);
    if (!messages || !messages.length) return;

    try {
      var hiddenUntil = parseInt(localStorage.getItem(HIDE_KEY) || '0', 10);
      if (hiddenUntil && Date.now() < hiddenUntil) return;
    } catch (e) {}

    var el = document.getElementById('jn-offer-banner');
    if (!el) return;

    var track = document.createElement('div');
    track.className = 'jn-offer-track';
    // Jede Botschaft bekommt ihren eigenen Link; fuer einen nahtlosen Loop wird die ganze Reihe verdoppelt.
    function buildSegment() {
      return messages.map(function (m) {
        return '<a class="jn-offer-link" href="' + m.href + '"><span class="jn-offer-msg">' + m.emoji + ' ' + m.html + '</span></a>';
      }).join('');
    }
    track.innerHTML = buildSegment() + buildSegment();
    el.appendChild(track);

    var close = document.createElement('button');
    close.id = 'jn-offer-close';
    close.setAttribute('aria-label', 'Banner schließen');
    close.textContent = '✕';
    close.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      el.classList.remove('jn-offer-show');
      try { localStorage.setItem(HIDE_KEY, String(Date.now() + 24 * 60 * 60 * 1000)); } catch (err) {}
    });
    el.appendChild(close);

    requestAnimationFrame(function () { el.classList.add('jn-offer-show'); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
